const template = require('./index.html')
const makeItLabel = require('@isoftdata/label')
const { v4: uuid } = require('@lukeed/uuid')

module.exports = function makeSelectComponent({
	twoway = false,
	lazy = true,
	isolated = true,
} = {}) {
	// eslint-disable-next-line no-undef
	return Ractive.extend({
		template,
		twoway,
		lazy,
		isolated,
		partials: {
			append: [],
			prepend: [],
		},
		components: {
			itLabel: makeItLabel(),
		},
		attributes: {
			required: [],
			optional: [
				'label',
				'class',
				'showLabel',
				'styleClass',
				'hasError',
				'disabled',
				'isLoading',
				'savedInputIdList',
				'showEmptyOption',
				'emptyText',
				'emptyValue',
				'labelId',
				'sizeClass',
				'multiple',
				'labelParentDivClass',
				'labelClass',
				'title',
			],
		},
		data() {
			return {
				id: uuid(),
				label: null,
				value: '',
				class: '',
				showLabel: true,
				styleClass: '',
				hasError: false,
				disabled: false,
				isLoading: false,
				wasSaved: false,
				savedInputIdList: [],
				showEmptyOption: true,
				emptyText: '',
				emptyValue: '',
				labelId: null,
				sizeClass: 'custom-select-sm',
				multiple: false,
				labelParentDivClass: 'form-group',
				labelClass: '',
				title: '',
			}
		},
		oninit() {
			//this.observe('value', v => console.log(v))
		},
	})
}
